import { trackLuckySpinWithGTM } from "./tracking";
import { isOnViewport, isHrefLocation } from "./utils";
import * as url from "url";

//
// lucky spin option
//

export function luckySpinOption() {
  const lsParamCookie = parseInt(Cookies.get('ls_param'));

  if ((lsParamCookie === undefined) || (lsParamCookie !== 0)) { return; }

  trackLuckySpinWithGTM('shown');

  const spinWithVideo = document.querySelector('.js-spin-with-video')

  if (!spinWithVideo) { return; }

  spinWithVideo.addEventListener('click', event => {
    event.preventDefault();

    document.querySelector('.js-spin-with-video').remove();
    document.querySelector('.joker-lucky-spin-block .js-spin').click();
  });
}

// handle pause page

export function handlePausePage() {
  if (!isHrefLocation('/pause')) { return; }

  document.addEventListener('rewarded_video_response', function (event) {
    const explanation = document.getElementById('explanation-text');
    const btn = document.querySelector('.btn.btn-with-spinner');
    const spinner = btn.querySelector('.btn-spinner');

    if (btn && spinner) {
      btn.classList.remove('btn-with-spinner');
      spinner.remove();
    }

    if (!event.detail.isEmpty) {
      explanation.style.display = 'block';
    }

    let rewarded_fill = event.detail.isEmpty ? 'no' : 'yes';

    if (!explanation) {
      rewarded_fill = 'na';
    }

    dataLayer.push({ rewarded_fill, insert: Cookies.get('insert_count') })
  });
}

// handle answer page with complete option

export function handleAnswerPageWithCompleteOption() {
  if (!document.querySelector('.answer-show-complete')) { return; }

  document.addEventListener('rewarded_video_response', function (event) {
    const $textWithAd = document.querySelector('.with-ad');
    const $textNoAd = document.querySelector('.no-ad');

    if (!event.detail.isEmpty) {
      $textWithAd.classList.remove('hidden-section');
    }
    else {
      $textNoAd.classList.remove('hidden-section');
    }

    let rewarded_fill = event.detail.isEmpty ? 'no' : 'yes';

    if (typeof event.detail.isEmpty == 'undefined') {
      rewarded_fill = 'na';
    }

    dataLayer.push({
      rewarded_fill,
      content_token: location.pathname.split('/')[3],
      domain: location.hostname
    });
  });
}

// handle Google rewarded video

export function handleRewardedVideo(App) {
  const rewardedVideoButtonClass = '.with-rewarded-video';
  const activationButton = document.querySelector(rewardedVideoButtonClass);
  const crossSellPopup = document.getElementById('x-sell-popup');
  const luckySpinAction = document.querySelector('.js-post-spin-action');

  let eventName = 'play_with_jokers';
  const contentToken = location.pathname.split("/")[3];
  const dataLayerObject = {
    domain: location.hostname,
    content_token: contentToken,
  };

  if (crossSellPopup) {
    eventName = 'cross_sell_popup';
  }

  if (luckySpinAction) {
    eventName = 'lucky_spin_action';
  }

  if (!activationButton && !crossSellPopup) { return; }

  App.on('seen_rewarded_video', event => {
    if (window._GRV_watched) {
      dataLayerObject[eventName] = 'seen_rewarded_video';
      dataLayer.push(dataLayerObject);
    }

    if (window._GRV_redirect_url) {
      location.href = window._GRV_redirect_url;
    }
  });

  document.addEventListener('click', event => {

    if (event.target.closest('a[data-age-widget]')) {
      event.preventDefault();
      return;
    }

    if (!event.target.closest(rewardedVideoButtonClass)) {
      return;
    }

    if (eventName === 'play_with_jokers') {
      const jParam = 'j_param_' + contentToken.toLowerCase();
      Cookies.set(jParam, '1');
    }

    dataLayerObject[eventName] = 'click_next';
    dataLayer.push(dataLayerObject);

    if (!window._GRV_available) {
      let urlToRedirect = event.target.href;

      if (urlToRedirect === undefined) {
        urlToRedirect = event.target.parentNode.href;
      }

      location.href = urlToRedirect;
    }
  });
}

// play without lifelines

export function handlePlayWithoutLifelines() {
  const contentToken = location.pathname.split("/")[3];
  let actionButtons = document.querySelectorAll('.play-without-lifelines, .play-without-jokers');

  actionButtons.forEach(actionButton => {
    actionButton.addEventListener('click', event => {
      const jParam = 'j_param_' + contentToken.toLowerCase();
      Cookies.set(jParam, '0');
    });
  });
}

//
// show shorten text option,
// only on mobile
//

export function showShortenText() {
  const shortenText = document.querySelector('.show-shorten-text');

  if (!shortenText) { return; }

  const landscapeMaxChars = shortenText.dataset.maxCharsLandscape;
  const portraitMaxChars = shortenText.dataset.maxCharsPortrait;
  const maxChars = shortenText.dataset.maxChars;

  //  temporary solution
  const unlockQuestionsProducts = ['A13I36', 'NPJCYO', '0MZYRN', '5V2ZFM', '99T79U'];
  if (unlockQuestionsProducts.includes(location.pathname.split("/")[3])) { return; }

  let charsLength = landscapeMaxChars || maxChars;

  if (window.innerHeight > window.innerWidth) {
    charsLength = portraitMaxChars || maxChars;
  }

  if (shortenText.textContent.trim().length > charsLength) {
    $('.show-shorten-text').shorten({ chars: charsLength, more: shortenText.dataset.shortenMore });

    shortenText.addEventListener('shorten::expand', () => $('.show-shorten-text').shorten('destroy'));
  }
}

//
// show user score number on gimmemore mobile via auto increment from 0 to its actual result
//

export function numberAutoCounter() {
  const $counter = $('.js-count-me');

  if (!$counter.length) {
    return
  }

  setTimeout(() => {
    $counter.closest('h1').fadeIn();
    $counter.prop('Counter', 0).animate({ Counter: $counter.text() }, {
      duration: 4000,
      easing: 'swing',
      step(now) {
        return $counter.text(Math.ceil(now));
      }
    });
  }, 7000)
}

//
// show user result visualisation on gimmemore mobile via graphical chart
//

export function chartAutoProgress() {
  const chart = document.querySelector('.js-chart-progress');

  if (!chart) {
    return
  }

  let chartProgress = setInterval(() => {
    if (chart.offsetWidth > 0 && chart.offsetHeight > 0) {
      clearInterval(chartProgress);
      chart.style.transform = `rotate(${chart.dataset.percentage}deg)`;
    }
  }, 100);
}

//
// progress bar dynamic increase based on questions completed
//

export function completionBarAutoProgress() {
  const bar = document.querySelector('.js-bar-progress');

  if (!bar) {
    return
  }

  let barProgress = setInterval(() => {
    if (bar.offsetWidth > 0 && bar.offsetHeight > 0) {
      clearInterval(barProgress);
      bar.style.width = bar.dataset.percentage + '%';
    }
  }, 100);
}

export function fiftyFiftyJoker() {
  if ((location.href.indexOf('joker=gethelp') !== -1) && document.querySelector('.fiftyfifty-modal')) {
    document.querySelector('.joker-btn[data-modal=fiftyfifty-modal]').click();
  }
}

//
// IQ Test Landing
//

export function iqTestLandingInit() {
  let slider;
  let hasControl = false;
  const $button = $('.premium-landing-page .floating-button, .landing-page .floating-button, .enneagram-landing-page .floating-button');
  const testimonialsContainer = document.querySelector(".iq-premium .testimonials-list, .iq-landing-theme .testimonials-list, .enneagram-premium .testimonials-list");
  const isMobile = document.querySelector('body').classList.contains('mobile');

  if (isMobile && document.querySelector('.enneagram-premium')) {
    hasControl = true;
  }

  if (testimonialsContainer) {
    slider = tns({
      container: testimonialsContainer,
      controls: hasControl,
      controlsText: hasControl ? ["<", ">"] : ["prev", "next"],
      nav: false,
      autoplayButtonOutput: false,
      mouseDrag: true,
      speed: 2000,
      edgePadding: 10,
      autoplay: true,
      autoplayTimeout: 5000,
      slideBy: 1,
      autoHeight: true,
      responsive: {
        320: {
          loop: false,
          rewind: false,
          items: 1,
        },
        700: {
          loop: true,
          items: 2,
          gutter: 25,
          edgePadding: 100,
          rewind: false,
        },
        1000: {
          loop: true,
          items: 3,
          gutter: 25,
          edgePadding: 40,
          rewind: true,
        },
        1100: {
          loop: true,
          items: 4,
          gutter: 25,
          edgePadding: 40,
          rewind: true,
        },
      },
    });
  }

  window.onscroll = () => {
    if ($button.length) {
      window.pageYOffset > 450
        ? $button.show(500)
        : $button.hide(500);
    }

    if (testimonialsContainer) {
      isOnViewport(testimonialsContainer)
        ? slider.play()
        : slider.pause();
    }
  };
}

//
// Unlock question button
//

export function handleUnlockQuestionButton() {
  const $button = $('.activate-cross-sell-popup');
  if (!$button.length) { return; }

  const $popup = $('#x-sell-popup');
  const $unlockQuestionBgExists = $('.unlock-questions-bg').length;

  $(document).on('click', '.modals .close, .modals.page.active', function(e) {
    if ($unlockQuestionBgExists && (e.target === this)) {
      $('.unlock-questions-bg').hide();
    }
  });

  $button.on('click', function() {
    if ($unlockQuestionBgExists) {
      $('.unlock-questions-bg').show();
    }

    dataLayer.push({
      event: 'unlock_question_button_click',
      domain: location.hostname,
      content_token: location.pathname.split("/")[3],
    });

    $popup.modal('show');

    return false;
  });
}

//
// Passing round page number into dfp for quiz universe round page
//
export function handleQuizUniverseRoundPage() {
  const roundPage = document.querySelector(".round-page");

  if (!roundPage) { return; }

  let roundNumber = roundPage.dataset.roundNumber ? Number(roundPage.dataset.roundNumber) : null;

  dataLayer.push({
    quiz_universe_round_complete: roundNumber
  });
}

//
// Timer
//

export function handleTimer() {
  const timer = document.querySelector(".timer-widget");

  if (!timer) { return; }

  const timerWrapper = timer.querySelector("p");
  const timerWrapperOffset = timer.getBoundingClientRect();

  window.onscroll = function() {
    if ((document.documentElement.scrollTop > timerWrapperOffset.top) && !timerWrapper.classList.contains('fixed')) {
      return timerWrapper.classList.add('fixed');
    } else if ((document.documentElement.scrollTop <= timerWrapperOffset.top) && timerWrapper.classList.contains('fixed')) {
      return timerWrapper.classList.remove('fixed');
    }
  };

  const timerEnd = timer.getAttribute('data-timer-end');
  return setInterval(function() {
      const now = new Date().getTime() / 1000;
      const timeLeft = timerEnd - now;

      if (timeLeft > 0) {
        let minutes = Math.floor((timeLeft % (60 * 60)) / 60) + '';
        let seconds = Math.floor(timeLeft % 60) + '';
        if (minutes.length === 1) {
          minutes = '0' + minutes;
        }
        if (seconds.length === 1) {
          seconds = '0' + seconds;
        }
        timer.querySelector("p span").innerHTML = minutes + ':' + seconds;
      } else {
        timer.querySelector("p span").innerHTML = "00:00";
      }
    }
    , 1000);
}

// user answers video option

export function handleUserAnswersVideoOption(App) {
  let playVideoCookie = Cookies.get('sa_play');
  if (!playVideoCookie) { return; }

  if (document.querySelector('.game-complete-page')) {
    Cookies.set('sa_play', '1');
  }

  App.on('rewarded_slot_displayed', function() {
    Cookies.set('sa_play', '0');
  });
}

export function saveUserDeviceWidth() {
  Cookies.set('device_width', window.innerWidth);
}

//
// Quiz Daily
//

export function handleQuizDailyOfferWall() {
  let $quizDailyWall = document.querySelector('.quiz-daily');

  if (!$quizDailyWall) {
    return;
  }

  const pageCooldown = document.querySelector('.offers-cooldown');
  const currentTimestampCookie = Cookies.get('t_stamp') ? parseInt(Cookies.get('t_stamp')) : null;
  const pageCooldownTimer = document.getElementById('cooldown-header-timer');
  let $quizDailyList = document.querySelectorAll('.quiz-daily-list li a');

  if (currentTimestampCookie && pageCooldown) {
    const _cooldown = pageCooldown.getAttribute('data-offers-cooldown-period');
    const timerDays = _cooldown.split(':')[0];
    const timerHours = _cooldown.split(':')[1];
    const timerMinutes = _cooldown.split(':')[2];
    const timerSeconds = _cooldown.split(':')[3];

    let lastGameTimestamp = parseInt(pageCooldown.getAttribute('data-offers-cooldown-timestamp'));
    let currentTimestamp = moment(currentTimestampCookie).toISOString()
    let endTimestamp = null;

    if (parseInt(timerDays) > 0) {
      endTimestamp = moment(lastGameTimestamp).add(timerDays, 'd');
    }

    if (parseInt(timerHours) > 0) {
      endTimestamp = endTimestamp !== null ?
          moment(endTimestamp).add(timerHours, 'h') :
          moment(lastGameTimestamp).add(timerHours, 'h');
    }

    if (parseInt(timerMinutes) > 0) {
      endTimestamp = endTimestamp !== null ?
          moment(endTimestamp).add(timerMinutes, 'm') :
          moment(lastGameTimestamp).add(timerMinutes, 'm');
    }

    if (parseInt(timerSeconds) > 0) {
      endTimestamp = endTimestamp !== null ?
          moment(endTimestamp).add(timerSeconds, 's') :
          moment(lastGameTimestamp).add(timerSeconds, 's');
    }

    endTimestamp = moment(endTimestamp).toISOString();

    if (moment(endTimestamp).isAfter(moment(currentTimestamp).toDate())) {
      renderCountdown(new Date(currentTimestamp), new Date(endTimestamp));
    } else {
      activateGames();
    }

  } else {
    activateGames();
  }

  $quizDailyList.forEach(game => {
    game.addEventListener('click', (e) => {
      e.preventDefault();

      if (Cookies.get('uid') && game.classList.contains('active')) {
        location.href = decodeURI(game.getAttribute('data-src')).replace('{device_id}', Cookies.get('uid'));
      }
    });
  });

  function activateGames() {
    $quizDailyList.forEach(game => {
      game.classList.remove('waiting');
      game.classList.add('active');
    });

    if (!!pageCooldownTimer) {
      pageCooldownTimer.innerHTML = 'NOW';
    }
  }

  function renderCountdown(dateStart, dateEnd) {
    let currentDate = dateStart.getTime();
    let targetDate = dateEnd.getTime()
    let days, hours, minutes, seconds;
    let count = 0;
    let intervalTimer = setInterval(function () {
      getCountdown(count++);
    }, 1000);

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function getCountdown(c) {
      let secondsLeft = ((targetDate - currentDate) / 1000) - c;
      days = pad(Math.floor(secondsLeft / 86400));
      secondsLeft %= 86400;
      hours = pad(Math.floor(secondsLeft / 3600));
      secondsLeft %= 3600;
      minutes = pad(Math.floor(secondsLeft / 60));
      seconds = pad(Math.floor(secondsLeft % 60));

      if (parseInt(days) === 0
          && parseInt(hours) === 0
          && parseInt(minutes) === 0
          && parseInt(seconds) === 0
      ) {

        activateGames();
        clearInterval(intervalTimer);

      } else if (!!pageCooldownTimer) {

        let displayDays = parseInt(days);
        let displayHours = parseInt(hours);
        let displayMinutes = parseInt(minutes);
        let displaySeconds = parseInt(seconds);
        let _suffix;

        if (displayDays > 0) {

          let _daysSuffix = (displayDays === 1) ? ' day' : ' days';
          _suffix = (displayHours === 1) ? ' hour' : ' hours';
          pageCooldownTimer.innerHTML = displayDays + _daysSuffix + ' ' + hours + _suffix;

        } else if (displayHours > 0) {

          _suffix = (displayHours === 1) ? ' hour' : ' hours';
          pageCooldownTimer.innerHTML = hours + ':' + minutes + _suffix;

        } else if (displayMinutes > 0) {

          _suffix = (displayMinutes === 1) ? ' minute' : ' minutes';
          pageCooldownTimer.innerHTML = minutes + ':' + seconds + _suffix;

        } else if (displaySeconds > 0) {

          _suffix = (displaySeconds === 1) ? ' second' : ' seconds';
          pageCooldownTimer.innerHTML = minutes + ':' + seconds + _suffix;

        }

      }
    }
  }
}

export function handleShowUserAnswersGraphOnMobileAnswerPage() {
  let block = document.querySelector('.question-page-other-people-answered');

  if (!block) { return; }

  let answerButtons = block.querySelectorAll('.game-answers a');
  let widget = block.querySelector('.widget');
  let widgetAdBlock = widget.querySelector('.ad-code');
  let widgetTitle = widget.querySelector('.user-answers-horizontal-title');
  let widgetDiagram = widget.querySelector('.user-answers-horizontal-diagram');
  let widgetNextButton = block.querySelector('.user-answers-horizontal-next-button');

  answerButtons.forEach((answerButton) => {
    answerButton.addEventListener("click", function (event) {
      event.preventDefault();

      let urlToRedirect = event.target.href;
      if (urlToRedirect === undefined) {
        urlToRedirect = event.target.parentNode.href;
      }

      widgetNextButton.querySelector('a').href = urlToRedirect;

      fetch(urlToRedirect)
          .then(response => {
            widgetNextButton.querySelector('a').href = response.url;
          });

      let macrosValueToReplace = answerButton.innerText;
      if (!macrosValueToReplace) {
        let imageAnswerSrcUserClickedOn = answerButton.querySelector('img').dataset.imageSrc;
        let relatedAnswerImage = document.querySelector('.user-answers-horizontal-diagram img[data-image-src="'+imageAnswerSrcUserClickedOn+ '"]');
        let textAnswer = relatedAnswerImage.closest('li').querySelector('.answer-label').innerHTML;
        macrosValueToReplace = textAnswer;
      }

      widgetTitle.innerHTML = widgetTitle.dataset.title.replace('{userAnswer}', macrosValueToReplace);
      widget.style.display = 'block';

      window.scrollTo({
        left: 0,
        top: widget.offsetTop - 30,
        behavior: 'smooth'
      });

      setTimeout(function () {
        let widgetAdBlockAd = widgetAdBlock.querySelector('center > div');
        widgetAdBlockAd.style.marginLeft = 0;
        widgetAdBlockAd.style.marginRight = 0;
        widgetAdBlock.style.opacity = 1;
      }, 0);
      setTimeout(function(){ widgetTitle.style.opacity = 1; }, 500);
      setTimeout(function(){ widgetDiagram.style.opacity = 1; }, 1000);
      setTimeout(function(){ widgetNextButton.style.opacity = 1; }, 1500);

      return false;
    });

  });
}

export function handleQuizUniverseAnswer() {
  let block = document.querySelector('.quiz-universe-answers');

  if (!block) { return; }

  let answerButtons = block.querySelectorAll('.game-answers a');
  let alreadyAnswered = false;

  if (alreadyAnswered === false) {
    answerButtons.forEach((answerButton) => {
      answerButton.addEventListener("click", function (event) {
        if (!window._GRV_available) {
          event.preventDefault();

          let urlToRedirect = event.target.href;
          if (urlToRedirect === undefined) {
            urlToRedirect = event.target.closest('a').href;
          }

          let answerToken = urlToRedirect.split("/")[8];
          let urlToCheckAnswer = block.getAttribute('data-check-answer-url') + '/' + answerToken;
          fetch(urlToCheckAnswer)
              .then(response => response.json())
              .then(data => {
                let answerButtonClass = 'incorrect';
                if (data.isAnswerCorrect === true) {
                  answerButtonClass = 'correct';

                  let scoreElement = document.createElement("div");
                  let scorePerCorrectAnswer = 10;
                  let text = document.createTextNode('+' + scorePerCorrectAnswer);
                  let liContainer = event.target.closest('li');
                  scoreElement.className = 'addToScore';
                  scoreElement.appendChild(text);
                  liContainer.append(scoreElement);

                  let userProgressWrapper = document.querySelector('.user-score');
                  let userProgress = userProgressWrapper.querySelector('span');
                  let userProgressTopPosition = userProgress.getBoundingClientRect().top;
                  let userProgressLeftPosition = userProgress.getBoundingClientRect().left;

                  let scoreElementLeftPosition = String(window.scrollX + liContainer.getBoundingClientRect().left + liContainer.getBoundingClientRect().width / 2) + 'px';
                  let scoreElementTopPosition = String(window.scrollY + liContainer.getBoundingClientRect().top + liContainer.getBoundingClientRect().height / 2) + 'px';

                  scoreElement.style.top = scoreElementTopPosition;
                  scoreElement.style.left = scoreElementLeftPosition;

                  scoreElement.style.top = window.scrollY + userProgressTopPosition + 'px';
                  scoreElement.style.left = window.scrollX + userProgressLeftPosition + 'px';
                  scoreElement.style.textShadow = 'none';
                  scoreElement.style.fontSize = '23px';
                  scoreElement.style.opacity = '0.5';

                  userProgress.innerText = String(Number(userProgress.innerText) + scorePerCorrectAnswer);
                }

                event.target.closest('a').classList.add(answerButtonClass);
                alreadyAnswered = true;
              })
              .finally(() => {
                if (!!document.querySelector('.app-download.active')) {
                  return;
                }

                setTimeout(function () {
                  window.location.href = urlToRedirect;
                }, 500);
              });
        }
      });
    });
  }
}

export function triggerAnswerSubmitEvent() {
  let answers = document.querySelectorAll('.game-answers .btn, .game-answer-input button[type=submit]');
  if (!answers) { return; }

  answers.forEach(answer => {
    answer.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('answer_submitted'));
    });
  });
}

export function quizUniverseComSliderInit() {
  if (!document.querySelector('body').classList.contains('quiz-universe-theme')) {
    return;
  }

  const testimonialsContainer = document.querySelector('.slider-container') || document.querySelector('section.section-with-slider');
  let slider;

  if (testimonialsContainer) {
    slider = tns({
      container: testimonialsContainer,
      controls: false,
      controlsText: false,
      nav: true,
      navPosition: true,
      autoplayButtonOutput: false,
      mouseDrag: true,
      speed: 1000,
      autoplay: true,
      autoplayTimeout: 10000,
      slideBy: 1,
      autoHeight: true,
      center: true,
      responsive: {
        320: {
          loop: false,
          items: 1,
          gutter: 0,
          edgePadding: 25,
        },
        640: {
          loop: true,
          items: 2,
          gutter: 0,
          edgePadding: 50,
        },
        768: {
          loop: true,
          items: 2,
          gutter: 0,
          edgePadding: 50,
        },
        1024: {
          loop: true,
          items: 3,
          gutter: 0,
          edgePadding: 125,
        },
      },
    });

    isOnViewport(testimonialsContainer)
        ? slider.play()
        : slider.pause();
  }
}
